export default function generateCSSRule(selector, cssDeclaration) {
  return "".concat(selector, "{").concat(cssDeclaration, "}");
}